/* 
Image utility functions.
*/

export const imageHelper = {
  srcFromBase64
};

function srcFromBase64(base64)
{
  return `data:image/png;base64,${base64}`;
}
